{
  "version": 1,
  "asset_id": "52a3178b-c31c-4d29-a1ab-1d55ec579f19",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/52a3178b-c31c-4d29-a1ab-1d55ec579f19/hiatal-intro-fundus-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/52a3178b-c31c-4d29-a1ab-1d55ec579f19/hiatal-intro-fundus-es-800.webp",
  "original_filename": "hiatal-intro-fundus-es-800.webp",
  "size": 44400,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:54:40Z"
}
